import React from 'react';
import Box from '@mui/material/Box';
export const FilledCircle: React.FC<{
  backgroundColor: string;
  children: React.ReactNode;
}> = ({ backgroundColor, children }) => (
  <Box
    sx={{
      width: 50,
      height: 50,
      borderRadius: '50%',
      backgroundColor: backgroundColor,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
    data-testid="filled-circle"
  >
    {children}
  </Box>
);
